import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { _Response } from '../domain/_response';
import { _Request } from '../domain/_request';
import { AbstractService } from './abstractService';
import { Nature } from '../domain/Nature';
import { Utils } from './utils';
import { Groupe } from '../domain/academicien';
import { PaysService } from './PaysService';


@Injectable()
export class GroupeService extends AbstractService<Groupe>{
  table = "groupe";
  libelle ="Groupe academicien";
  
  constructor(private http: HttpClient, 
    private utils:Utils) { 
    super();
    this._request.data = {};
    if(!this.entities){
      this.getEntities();
    }
  }

  getHttp() {
    return this.http;
  }
  getUtils(){
    return this.utils;
  }

  beforeRequest(){
    if(this._request.data && this.getFromLocalStorage('paysSelected')){
      this._request.data.paysId = JSON.parse(this.getFromLocalStorage('paysSelected')).id;
    }
    if(this._request.datas && this.getFromLocalStorage('paysSelected')){
      this._request.datas[0].paysId = JSON.parse(this.getFromLocalStorage('paysSelected')).id;
    } 
  }
}